(function () {
  'use strict';

  function init() {
    const stickyBar = document.getElementById('jc-sticky-cart');
    if (!stickyBar) return;

    let retries = 0;
    const MAX_RETRIES = 20; // 20 * 100ms = 2s

    function findInlineCTA() {
      return document.querySelector('.jc-blk4__add-btn')
        || document.querySelector('product-form [type="submit"]')
        || document.querySelector('form[action$="/cart/add"] [type="submit"]');
    }

    function setup(inlineCTA) {
      // productForm: ボタンの .form プロパティ（form属性 or DOM祖先）で正確に取れる
      const productForm = inlineCTA.form || inlineCTA.closest('form');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              stickyBar.classList.remove('is-visible');
              stickyBar.setAttribute('aria-hidden', 'true');
            } else {
              const rect = inlineCTA.getBoundingClientRect();
              if (rect.bottom < 0) {
                stickyBar.classList.add('is-visible');
                stickyBar.setAttribute('aria-hidden', 'false');
              }
            }
          });
        },
        { threshold: 0 }
      );

      observer.observe(inlineCTA);

      const stickyButton = stickyBar.querySelector('[data-sticky-add-to-cart]');
      if (stickyButton && productForm) {
        stickyButton.addEventListener('click', () => {
          const submitBtn = productForm.querySelector('[type="submit"], button[name="add"]')
            || inlineCTA;
          if (submitBtn && !submitBtn.disabled) {
            if (typeof productForm.requestSubmit === 'function') {
              productForm.requestSubmit(submitBtn);
            } else {
              submitBtn.click();
            }
          }
        });
      }

      const priceEl = stickyBar.querySelector('[data-sticky-price]');
      const summaryEl = stickyBar.querySelector('[data-sticky-variant-summary]');

      // jc-sale-price.js からの最終受信値（salePrice は円の整数。null = セールなし）
      let lastSalePrice = null;

      document.addEventListener('variant:change', handleVariantChange);

      document.addEventListener('jc:sale-price-applied', (event) => {
        const detail = event?.detail || {};
        lastSalePrice = typeof detail.salePrice === 'number' ? detail.salePrice : null;
        if (lastSalePrice !== null) {
          setAmountText('¥' + lastSalePrice.toLocaleString('ja-JP'));
        } else {
          // セール解除時: 非表示 Dawn price の MutationObserver はセクション再取得の
          // DOM差し替えで発火しなくなるため、PDP可視価格（jc-variant-picker が
          // 直前に書いた定価）を転記して古いセール価格が残らないようにする
          const mainVisible = document.querySelector('[data-price-area] [data-price]');
          if (mainVisible && mainVisible.textContent.trim()) {
            setAmountText(mainVisible.textContent.trim());
          }
        }
      });

      function setAmountText(text) {
        if (!priceEl) return;
        const amountEl = priceEl.querySelector('.sticky-cart__price-amount');
        if (amountEl) amountEl.textContent = text;
      }

      const sectionId = document.querySelector('[data-section-id]')?.dataset.sectionId
        || document.querySelector('.product')?.closest('.section-template--product')?.id?.replace('shopify-section-', '');

      if (sectionId) {
        document.addEventListener(`variant:change:${sectionId}`, handleVariantChange);
      }

      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        const mainPriceEl = productInfo.querySelector('.price__regular .price-item--regular, .price-item--sale');
        if (mainPriceEl) {
          const priceObserver = new MutationObserver(() => {
            syncPriceFromMain();
          });
          priceObserver.observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
        }

        const variantInput = productInfo.querySelector('input[name="id"]');
        if (variantInput) {
          const inputObserver = new MutationObserver(() => {
            syncVariantSummary();
            syncSoldOutState();
          });
          inputObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        }
      }

      // 初期状態でインラインCTAの disabled/soldout を反映
      syncSoldOutState();

      // インラインCTAの disabled / classList 変化を監視して sticky bar も同期
      const ctaObserver = new MutationObserver(() => {
        syncSoldOutState();
      });
      ctaObserver.observe(inlineCTA, { attributes: true, attributeFilter: ['disabled', 'class'] });

      function handleVariantChange(event) {
        const variant = event?.detail?.variant;
        if (!variant) return;
        updateStickyBar(variant);
      }

      function updateStickyBar(variant) {
        if (priceEl) {
          const amountEl = priceEl.querySelector('.sticky-cart__price-amount');
          if (amountEl) {
            const formatted = (window.Shopify && Shopify.formatMoney)
              ? Shopify.formatMoney(variant.price)
              : '¥' + (variant.price / 100).toLocaleString('ja-JP');
            amountEl.textContent = formatted;
          }
        }
        if (summaryEl) {
          summaryEl.textContent = variant.title !== 'Default Title' ? variant.title.replace(' / ', ' / ') : '';
        }
      }

      function syncPriceFromMain() {
        if (!priceEl) return;
        // セール価格受信済みなら、非表示 Dawn price（元価格）での上書きより優先する
        if (lastSalePrice !== null) {
          setAmountText('¥' + lastSalePrice.toLocaleString('ja-JP'));
          return;
        }
        const amountEl = priceEl.querySelector('.sticky-cart__price-amount');
        if (!amountEl) return;
        const mainPrice = document.querySelector('product-info .price__regular .price-item--regular, product-info .price-item--sale');
        if (mainPrice) {
          amountEl.textContent = mainPrice.textContent.trim();
        }
      }

      function syncVariantSummary() {
        if (!summaryEl) return;
        const selectedOptions = [];
        document.querySelectorAll('product-info fieldset .product-form__input input:checked, product-info fieldset .product-form__input select').forEach((el) => {
          const val = el.type === 'select-one' ? el.options[el.selectedIndex]?.textContent.trim() : el.value;
          if (val) selectedOptions.push(val);
        });
        summaryEl.textContent = selectedOptions.join(' / ');
      }

      function syncSoldOutState() {
        // インラインCTA の disabled / jc-vp__cart-soldout を sticky ボタンにも反映
        if (!stickyButton) return;
        const isDisabled = inlineCTA.disabled;
        const isSoldOut = inlineCTA.classList.contains('jc-vp__cart-soldout');
        stickyButton.disabled = isDisabled;
        stickyButton.classList.toggle('sticky-cart__button--disabled', isDisabled);
        stickyButton.classList.toggle('sticky-cart__button--soldout', isSoldOut);

        const stickyTextEl = stickyButton.querySelector('.jc-vp__cart-text') || stickyButton;
        if (isSoldOut) {
          stickyTextEl.textContent = '完売しました';
        } else {
          // 非売切 disabled（未選択）の場合も「カートに入れる」表記のまま
          stickyTextEl.textContent = 'カートに入れる';
        }
      }
    }

    function tryInit() {
      const inlineCTA = findInlineCTA();
      if (inlineCTA) {
        setup(inlineCTA);
        return;
      }
      retries++;
      if (retries >= MAX_RETRIES) {
        console.warn('[sticky-cart-bar] Inline CTA button not found after retries');
        return;
      }
      setTimeout(tryInit, 100);
    }

    tryInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
